<script>
import api from '../apiBridge'
import config from '../brandConfig'
import Navbar from './vuestrap/Navbar.vue'
import Dropdown from './vuestrap/Dropdown.vue'
import Spinner from './vuestrap/Spinner.vue'


export default {
 components: {
    'navbar': Navbar,
    'dropdown': Dropdown,
    'spinner': Spinner
    
  },

  methods: {

    getChannelExclusionList() {
/*      
        api.readFromStatic('config/orderChannelExclusionList.json', (data) => {
          api.appState.orderChannelExclusionList = data;
        });
*/


    },

    clickSoundPlay() {
      if (this.clickSound) {
        this.clickSound.play();
      }
    },

    orderSoundPlay() {
      if (this.orderSound) {
        this.orderSound.play();
      }
    },

    bumpSoundPlay() {
      if (this.bumpSound) {
        this.bumpSound.play();
      }
    },

    logout() {
      api.logout();

      this.appState = api.appState;

    }
  },

  data() {
    return {
      appState: api.appState
    }
  },

  mounted: function () {
    console.log('app container page loaded');

    // read any static config files
    this.getChannelExclusionList();

    this.clickSound = document.getElementById('clickSound');
    this.orderSound = document.getElementById('orderSound');
    this.bumpSound = document.getElementById('bumpSound');

//    this.clickSound.volume = 0.0;
//    this.orderSound.volume = 0.0;
//    this.bumpSound.volume = 0.0;

    

    // disable default page scrolling in iPad
/*    var body = document.getElementById('containerPage');
    body.addEventListener('touchmove', function(e) {
        e.preventDefault();

    }, false);
*/
  }

}
</script>


<template>
  <div>
    <router-view class="content-wrapper"></router-view>
  </div>
</template>




// WEBPACK FOOTER //
// App.vue?1a4c023a